module.exports = "/_next/static/images/nova-26fb1bdd404831f8f40f6710c868a4fa.png";